<template>
    <b-modal v-model="showModal" @hidden="cancelarSalvar" size="xl" hide-footer :title="prefix + title">
        <b-form @submit.prevent="submitForm">
            <b-tabs v-model="activeTab">
                <b-tab title="Identificação da Ata">
                    <div>
                        <b-card class='mt-3' bg-variant="light">
                            <b-row>
                                <b-col md="6">
                                    <LgFormInput v-model="form.numeroAta" :disabled="true" label="Número Ata:*" />
                                </b-col>

                                <b-col md="6">
                                    <LgFormInput v-model="form.licitacao" :disabled="isViewMode" label="Licitação:*" />
                                </b-col>

                                <b-col md="6">
                                    <LgFormInput v-model="form.processo" :disabled="isViewMode" label="Processo:*" />
                                </b-col>
                                <b-col md="6">
                                    <LgFormInput v-model="form.amparoLegal" :disabled="isViewMode"
                                        label="Amparo Legal:*" />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <LgFormDate label="Data Início Vigência:*" description='' v-model="form.dataInicial"
                                        :disabled="isViewMode" />
                                </b-col>
                                <b-col md="6">
                                    <LgFormDate label="Data Final Vigência:*" description='' v-model="form.dataFinal"
                                        :disabled="isViewMode" />
                                </b-col>

                                <b-col md="6">
                                    <LgFormDate label="Data da Assinatura:*" description=''
                                        v-model="form.dataAssinatura" :disabled="isViewMode" />
                                </b-col>
                                <b-col md="6">
                                    <LgFormDate label="Data Final Publicação:*" description=''
                                        v-model="form.dataPublicacao" :disabled="isViewMode" />
                                </b-col>


                                <b-col md="6">
                                    <b-form-group class="ml-2">
                                        <label style="color: black; text-decoration: none; font: 12px Inter sans-serif"
                                            for="check-button">Permite carona:*</label>
                                        <b-form-checkbox :disabled="isViewMode" v-model="form.permiteCarona"
                                            name="check-button" switch size="lg" :value="1" :unchecked-value="0" />
                                    </b-form-group>

                                </b-col>

                            </b-row>
                        </b-card>
                    </div>
                </b-tab>
                <b-tab title="Itens">
                    <b-row no-gutters class="my-2 d-flex justify-content-end">
                        <b-col md="12" class="d-flex justify-content-end">
                            <b-button v-if="processoCompra == null" @click="abrirModalAdicionarItem" variant="primary"
                                class="mb-2" :disabled="isViewMode">
                                +
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-table :items="form.itens" :fields="fields" responsive="sm" :busy="busy" show-details>
                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                        </template>


                        <template #cell(details)="data">
                            <b-button v-if="data.item.solicitacoes && data.item.solicitacoes.length > 0 && isViewMode"
                                @click="data.toggleDetails" variant="info" size="sm">
                                <b-icon icon="chevron-down" />
                            </b-button>

                        </template>

                        <template #cell(quantidade)="data">
                            <b-form-input @input="handleQuantidade(data.item)" style="height: 20px;"
                                :disabled="isViewMode" v-model="data.item.quantidade" type="number" min="1"
                                required></b-form-input>
                        </template>
                        <template #cell(disponivel)="data">
                            {{ Math.floor(data.item.quantidade * 50 / 100) - data.item.quantidadeCarona }}
                        </template>

                        <template #cell(valorUnit)="data">
                            <LgFormInput class='mt-3' v-model="data.item.valorUnit" type="text"
                                placeholder="Valor Unitário" @input="formatValorUnit(data.item)"
                                :disabled="isViewMode || processoCompra != null" />
                        </template>
                        <template #cell(total)="data">
                            <span>R$ {{ calcularTotalItem(data.item) }}</span>
                        </template>
                        <template #cell(acoes)="data">
                            <b-button @click="handleRemoveItem(data.index)" variant="danger" size="sm"
                                :disabled="isViewMode">
                                <b-icon icon="trash" />
                            </b-button>

                        </template>

                        <template #row-details="row">
                            <b-card-body v-if="row.item.solicitacoes && row.item.solicitacoes.length > 0 && isViewMode">
                                <b-table :items="row.item.solicitacoes" :fields="fieldsHistorico" responsive="sm"
                                    :busy="busy">

                                    <template #cell(historico)="data">
                                        <h5>
                                            {{ row.item.descricaoResumida + ' R$' + data.item.valorNovo + ' ' +
                                                data.item.ataSolicitacaoAtualizacaoValor.dhSolicitacao.split("-").reverse().join("/")
                                                + ' - ' + data.item.ataSolicitacaoAtualizacaoValor.justificativa }}
                                        </h5>
                                    </template>

                                </b-table>
                            </b-card-body>
                        </template>


                    </b-table>
                    <ModalConsultaProdutoCadastroEssencial v-if='showModalConsultaProdutoCadastroEssencial'
                        id="finderProdutoRegistroForm" @onselect="handleSelectProduto"
                        invalidFeedback="Informe um produto!" :prefix="prefix + title + ' > '" />
                </b-tab>

                <b-tab title="Participantes" :disabled="!tudoPreenchido">
                    <b-row no-gutters class="mt-3 d-flex justify-content-between align-items-center">
                        <b-col md="6">
                        </b-col>
                        <b-col md="6" class="d-flex justify-content-end">
                            <b-button @click="abrirModalEmpresa" variant="primary" class="mb-2"
                                :disabled="isViewMode && (isCarona == null ? isViewMode : !isCarona)">
                                +
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-table :items="form.participantes" :fields="participanteFields" responsive="sm" show-details
                        :busy="busy">
                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                        </template>

                        <template #cell(empresa)='data'>
                            <span>{{ data.item.empresa.razaoSocial }}</span>
                        </template>
                        <template #cell(tipo)='data'>
                            <LgFormConstSelect class='mt-4' v-model="data.item.tipo" :options="tipoParticipanteOptions"
                                :disabled="data.item.tipo == 1 ? true : (!isViewMode ? false : (isViewMode && isCarona == null ? isViewMode : (!isCarona || data.item.carona == 0)))"
                                @change="validarGerenciador(data.item)" />
                        </template>
                        <template #cell(acoes)="data">
                            <b-button v-if="data.item.tipo != 1 || (isCarona == isViewMode ? false : !isCarona)"
                                @click="form.participantes.splice(data.index, 1)" variant="danger" size="sm"
                                :disabled="data.item.saldoTotalUtilizado > 0 || (!isViewMode ? false : (isViewMode && isCarona == null ? isViewMode : (!isCarona || data.item.carona == 0)))">
                                <b-icon icon="trash" />
                            </b-button>
                        </template>

                        <template #cell(details)="data">

                            <b-button @click="data.toggleDetails" variant="info" size="sm">
                                <b-icon icon="chevron-down" />
                            </b-button>
                        </template>

                        <template #row-details="row">
                            <b-card-body>
                                <b-table :items="row.item.itens" :fields="fieldsItensParticipantes" responsive="sm"
                                    class="tabela-participantes-personalizada" :busy="busy">
                                    <template #table-busy>
                                        <div class="text-center text-primary my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                        </div>
                                    </template>

                                    <template #cell(produto)="data">
                                        <LgFormInput class='mt-3' :value="data.item.descricaoResumida"
                                            placeholder="Produto" disabled />
                                    </template>

                                    <template #cell(quantidade)="data">

                                        <b-form-input @change="itemParticipanteHandle(row.item, data.item)"
                                            style="height: 20px;"
                                            :disabled="isViewMode && (isCarona == null ? isViewMode : !isCarona || row.item.carona == 0)"
                                            v-model="data.item.quantidade" type="number" min="1"
                                            required></b-form-input>
                                    </template>
                                    <template #cell(unidade)="data">
                                        <LgFormInput class='mt-3' v-model="data.item.unidadeMedida"
                                            placeholder="Unidade" disabled />
                                    </template>
                                </b-table>
                            </b-card-body>
                        </template>
                    </b-table>
                    <LgFinderPageEmpresa ref="finderPageEmpresa" :prefix='[prefix, title]' :modalOnly="true"
                        id="finderPageEmpresa" @input='adicionarParticipante' />
                </b-tab>
                <b-tab title="Documentos">
                    <b-row no-gutters class="my-2 d-flex justify-content-end">
                        <b-col md="12" class="d-flex justify-content-end">
                            <b-button @click="abrirModalAdicionarDocumento" variant="primary" class="mb-2"
                                :disabled="isViewMode">
                                +
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-table :items="form.documentos" :fields="documentoFields" responsive="sm" :busy="busy">
                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                        </template>

                        <template #cell(tipo)="data">
                            <LgFormConstSelect class='mt-3' v-model="data.item.tipo" :options="tipoDocumentoOptions"
                                :disabled="isViewMode" />
                        </template>
                        <template #cell(descricao)="data">
                            <LgFormInput class='mt-3' v-model="data.item.descricao" placeholder="Descrição"
                                :disabled="isViewMode" />
                        </template>
                        <template #cell(datacriacao)="data">
                            <span>{{ formatDate(data.item.datacriacao) }}</span>
                        </template>
                        <template #cell(nomeArquivo)="data">
                            <b-link @click="baixarArquivo(data.item)" class="text-primary">
                                {{ data.item.nomeArquivo }}
                            </b-link>
                        </template>
                        <template #cell(acoes)="data">
                            <b-button @click="form.documentos.splice(data.index, 1)" variant="danger" size="sm"
                                :disabled="isViewMode">
                                <b-icon icon="trash" />
                            </b-button>
                        </template>
                    </b-table>
                    <input type="file" ref="fileInput" @change="handleFileChange" style="display: none;" />
                </b-tab>
            </b-tabs>
            <div class="d-flex justify-content-center mt-3">
                <b-button id="confirmarSalvar" @click="submitForm" variant="success" style="height: 30px" pill size="sm"
                    :disabled="(!isViewMode ? false : (isViewMode && isCarona == null ? isViewMode : !isCarona))">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="check-circle" />
                    </div>
                </b-button>
                <b-button id="cancelarSalvar" class="ml-2" @click="cancelarSalvar" style="height: 30px" pill size="sm"
                    variant="danger">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="x-circle" />
                    </div>
                </b-button>
            </div>


        </b-form>
    </b-modal>
</template>

<script>
import LgFinderPageEmpresa from "@/components/Finders/LgFinderPageEmpresa.vue"
import AtaService from "@/core/api/AtaService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ModalConsultaProdutoCadastroEssencial from "@/core/components/Modals/ModalConsultaProdutoCadastroEssencial.vue"
import { downloadArquivo } from "@/core/utils/DownloadArquivoUtil.js"
import ResourceService from "@/core/api/ResourceService"
import { ListResourceMixin } from "@/core/mixins/resource";

export default {
    components: {
        LgFormDate, LgFormConstSelect, LgFormInput,
        ModalConsultaProdutoCadastroEssencial, LgFinderPageEmpresa
    },
    mixins: [ListResourceMixin],
    props: {
        processoCompra: {
            type: Object,
            default: null
        },

        isCarona: {
            type: Boolean,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
        idAta: {
            type: Number,
            default: null,
        },
        isViewMode: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "Cadastrar"
        }
    },
    computed: {
        tudoPreenchido() {
            return this.form.itens && this.form.itens.length > 0 && this.form.itens.every(item => item.quantidade && item.quantidade > 0);
        }
    },
    data() {
        return {
            showModal: true,
            busy: false,
            activeTab: 0,
            showModalConsultaProdutoCadastroEssencial: false,
            showModalConsultaEmpresa: false,
            showModalAdicionarDocumento: false,
            form: {
                processoCompra: this.processoCompra == null ? null : this.processoCompra.id,
                permiteCarona: "",
                licitacao: "",
                amparoLegal: "",
                valorTotalAta: 0,
                numeroAta: "",
                processo: "",
                dataAssinatura: null,
                dataInicial: null,
                dataFinal: null,
                situacaoContrato: null,
                resumo: "",
                objetoDetalhado: "",
                participantes: [],
                itens: [],
                documentos: [],
            },
            modalidadeOptions: [
                { value: null, text: "Selecione a modalidade" },
                { value: "Contrato", text: "Contrato" },
            ],
            situacaoOptions: [
                { value: null, text: "Selecione a situação" },
                { value: "VIGENTE", text: "Vigente" },
                { value: "EXPIRADO", text: "Expirado" },
                { value: "ENCERRADO", text: "Encerrado" },
                { value: "NAO_INICIADO", text: "Não Iniciado" },
            ],
            fields: this.isViewMode ?
                [
                    { key: "details", label: " " },
                    { key: 'descricaoResumida', label: 'Produto', },
                    { key: 'quantidade', label: 'Quantidade' },
                    { key: 'quantidadeCarona', label: 'Quantidade Carona' },
                    { key: 'quantidadeRequisicao', label: 'Qtd. de Itens em Requisições de Compra' },

                    { key: 'disponivel', label: 'Disponível para Carona' },

                    { key: 'unidadeMedida', label: 'Unidade' },
                    { key: 'valorUnit', label: 'Valor Unitário' },
                    { key: 'total', label: 'Total' },
                    { key: 'acoes', label: '' },
                ] : this.processoCompra != null ? [{ key: 'produto.descricaoResumida', label: 'Produto' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'quantidadeRetirada', label: 'Quantidade Retirada' },
                { key: 'qtdMaxima', label: 'Quantidade Máxima' },


                { key: 'produto.unidadeMedida', label: 'Unidade' },
                { key: 'valorUnit', label: 'Valor Unitário' },
                { key: 'total', label: 'Total' },
                { key: 'acoes', label: '' },] : [
                    { key: 'descricaoResumida', label: 'Produto' },
                    { key: 'quantidade', label: 'Quantidade' },
                    { key: 'unidadeMedida', label: 'Unidade' },
                    { key: 'valorUnit', label: 'Valor Unitário' },
                    { key: 'total', label: 'Total' },
                    { key: 'acoes', label: '' },
                ],
            fieldsHistorico:
                [
                    { key: 'historico', label: 'Histórico' },

                ],
            fieldsItensParticipantes: this.isCarona ?
                [
                    { key: 'produto', label: 'Produto' },
                    { key: 'quantidade', label: 'Quantidade' },
                ]
                : [
                    { key: 'produto', label: 'Produto' },
                    { key: 'quantidade', label: 'Quantidade' },
                ],
            participanteFields: [
                { key: 'details', label: ' ' },

                { key: 'empresa', label: 'Empresa' },
                { key: 'tipo', label: 'Tipo Participante' },
                { key: 'acoes', label: '' },
            ],
            tipoParticipanteOptions: [
                { value: 1, text: 'Gerenciador' },
                { value: 2, text: 'Participante' }
            ],
            novoDocumento: {
                tipo: null,
                descricao: "",
                dataPublicacao: new Date().toISOString().substr(0, 10),
                arquivo: null,
                arquivoBytes: null,
            },
            tipoDocumentoOptions: [
                { value: null, text: "Selecione o tipo de documento" },
                { value: "5", text: "Ofício" },
                { value: "74", text: "Edital" },
                { value: "75", text: "Ata" },
                { value: "76", text: "Anexos" },
            ],
            documentoFields: [
                { key: 'nomeArquivo', label: 'Arquivo do Documento' },
                { key: 'tipo', label: 'Tipo do Documento' },
                { key: 'descricao', label: 'Descrição' },
                { key: 'datacriacao', label: 'Data de Inclusão' },
                { key: 'acoes', label: '' },
            ],
        }
    },
    async beforeMount() {

        if (this.idAta) {
            await this.carregarAta(this.idAta);
            if (this.processoCompra != null) {
                this.carregarItemProcessoCompra();

            }
        }
        else {
            var { data } = await new ResourceService("/api/configuracoes-sistema").get('114');
            this.form.participantes = [];
            if (data.valorPropriedade == null || data.valorPropriedade == "") {
                this.$notify({
                    type: "danger",
                    message: "Não é possível criar uma Ata sem um Orgão Gerenciador cadastrado.",
                });

                this.cancelarSalvar();

            }
            if (this.processoCompra != null) {
                await this.carregarItemProcessoCompra();

            }


            this.form.participantes.push({
                empresa: {
                    id: data.valorPropriedade,
                    razaoSocial: data.valorPropriedadeLabel
                },
                tipo: 1,
                idempresa: data.valorPropriedade,
                saldoTotalUtilizado: 0,
                itens: this.processoCompra == null ? [] : JSON.parse(JSON.stringify(this.form.itens))

            });
        }

    },
    methods: {
        handleQuantidade(item) {
            if (this.processoCompra != null) {
                if (item.quantidade > item.qtdMaxima) {
                    this.$notify({
                        message: `A quantidade do item ${item.descricaoResumida} não pode exceder ${item.qtdMaxima}.`,
                        type: 'danger',
                        solid: true
                    });
                    item.quantidade = 0;
                    return
                }
            }
        },

        async carregarItemProcessoCompra() {
            this.busy = true;
            var { data } = await new ResourceService('/api/processocompra').get(`${this.processoCompra.id}/${0}/itens-para-ata`);
            this.form.itens = data;
            this.busy = false;
        },
        handleRemoveItem(index) {

            this.form.participantes.itens.forEach(participante => {
                participante.itens.splice(index, 1)
            });

            this.form.itens.splice(index, 1)
        },
        itemParticipanteHandle(participante, item) {



            if (this.isCarona) {
                var totalItensCarona = this.calcularQuantidadeTotal();
                var totalItensParticipantesCarona = this.calcularQuantidadeTotalParticipantes();

                if (totalItensParticipantesCarona > (totalItensCarona + Math.floor(totalItensCarona * 50 / 100))) {
                    this.$bvToast.toast('A quantidade de itens total não pode ser maior que a quantidade geral prevista para a ata', {
                        title: 'Erro',
                        variant: 'danger',
                        solid: true
                    });

                    participante.itens.forEach(itemParticipante => {
                        if (item.idProduto == itemParticipante.idProduto)
                            itemParticipante.quantidade = 0;
                    });

                }
                return;

            }

            var totalItens = this.calcularQuantidadeTotal(item);
            var totalItensParticipantes = this.calcularQuantidadeTotalParticipantes(item);

            if (totalItensParticipantes > totalItens) {
                this.$bvToast.toast('A quantidade de itens não pode ultrapassar o valor total disponível da ata', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                });

                participante.itens.forEach(itemParticipante => {
                    if (item.idProduto == itemParticipante.idProduto)
                        itemParticipante.quantidade = 0;
                });

            }
        },
        handleSelectProduto(produtoDto) {

            let item = {}
            this.showModalConsultaProdutoCadastroEssencial = false

            if (produtoDto) {
                const itemExistente = this.form.itens.find(item => item.idProduto === produtoDto.id)
                if (itemExistente) {
                    this.$bvToast.toast('Item já adicionado.', {
                        title: 'Aviso',
                        variant: 'warning',
                        solid: true
                    });
                    return;
                }


                this.busy = true;

                item.descricaoResumida = produtoDto.descricaoResumida
                item.produto = produtoDto
                item.idProduto = produtoDto.id
                item.unidadeMedida = produtoDto.tipoMedida.descricao
                item.quantidade = 0
                item.valorUnit = 0
                this.form.itens.push(item)


                this.form.participantes.forEach(participante => {
                    var novoItem = JSON.parse(JSON.stringify(item));
                    novoItem.quantidade = 0;
                    participante.itens.push(novoItem);
                });
            }
            this.busy = false;
        },
        async submitForm() {


            if (!this.form.licitacao || !this.form.amparoLegal || !this.form.dataInicial || !this.form.dataFinal || !this.form.dataAssinatura || !this.form.dataPublicacao || !this.form.processo || this.form.processo == "" || this.form.participantes.length === 0 || this.form.itens.length === 0) {
                this.$bvToast.toast('Por favor, preencha todos os campos obrigatórios e adicione pelo menos um participante e um item.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }
            if (new Date(this.form.dataFinal) < new Date(this.form.dataInicial)) {
                this.$bvToast.toast('A data final não pode ser menor que a data inicial.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }
            if (this.form.participantes.some(participante => !participante.tipo)) {
                this.$bvToast.toast('Por favor, preencha o tipo de todos os participantes.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }
            if (this.form.documentos.some(documento => !documento.tipo)) {
                this.$bvToast.toast('Por favor, preencha o tipo de todos os documentos.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }
            if (this.form.itens.some(item => item.quantidade <= 0 || item.valorUnit <= 0)) {
                this.$bvToast.toast('Por favor, preencha a quantidade e o valor unitário de todos os itens corretamente.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }
            const formData = {
                ...this.form
            }
            try {
                await AtaService.create(formData)
                this.$bvToast.toast('Ata criada com sucesso!', {
                    title: 'Sucesso',
                    variant: 'success',
                    solid: true
                })
                this.$emit('close')
            } catch (error) {
                this.$bvToast.toast('Erro ao criar ata.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
            }
        },
        cancelarSalvar() {
            this.$emit('close')
        },
        resetForm() {
            this.form = {
                licitacao: "",
                amparoLegal: "",
                numeroAta: "",
                processo: "",
                valorTotalAta: 0,
                dataAssinatura: null,
                dataInicial: null,
                dataFinal: null,
                situacaoContrato: null,
                resumo: "",
                objetoDetalhado: "",
                participantes: [],
                documentos: [],
                itens: []
            }
            this.novoDocumento = {
                tipo: null,
                descricao: "",
                dataPublicacao: new Date().toISOString().substr(0, 10),
                arquivo: null,
                arquivoBytes: null,
            }
        },
        abrirModalAdicionarItem() {
            this.showModalConsultaProdutoCadastroEssencial = true
        },
        adicionarParticipante(novoParticipante) {
            const participanteExistente = this.form.participantes.find(participante => participante.idempresa === novoParticipante.id)
            if (!participanteExistente) {

                var itensNovos = JSON.parse(JSON.stringify(this.form.itens));

                itensNovos.forEach(itemNovo => {
                    itemNovo.quantidade = 0;
                })

                this.form.participantes.push({
                    empresa: {
                        razaoSocial: novoParticipante.razaoSocial,
                        id: novoParticipante.id
                    },
                    carona: this.isCarona ? 1 : 0,

                    itens: itensNovos,
                    idempresa: novoParticipante.id,
                    tipo: null,
                    saldoTotalUtilizado: 0,
                })
            } else {
                this.$bvToast.toast('Participante já adicionado.', {
                    title: 'Aviso',
                    variant: 'warning',
                    solid: true
                })
            }
        },
        abrirModalEmpresa() {
            this.$refs.finderPageEmpresa.show()
        },
        adicionarAnexo() {
            this.form.documentos.push({
                arquivo: this.novoDocumento.arquivo,
                nomeArquivo: this.novoDocumento.arquivo.name,
                tipo: this.novoDocumento.tipo,
                descricao: this.novoDocumento.descricao,
                dataInclusao: new Date().toISOString().slice(0, 10),
                arquivoBytes: this.novoDocumento.arquivoBytes
            })
            this.limparDocumento()
        },
        limparDocumento() {
            this.novoDocumento.tipo = null
            this.novoDocumento.descricao = ""
            this.novoDocumento.arquivo = null
            this.novoDocumento.arquivoBytes = null
        },
        formatDate(dateString) {
            if (!dateString) return "N/A"
            const date = new Date(dateString)
            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()
            return `${day}/${month}/${year}`
        },
        async convertFileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = () => resolve(reader.result.split(',')[1])
                reader.onerror = reject
                reader.readAsDataURL(file)
            })
        },
        formatValorUnit(item) {
            if (typeof item === 'string') {
                this.novoItem.valorUnit = item.replace(',', '.')
            } else {
                item.valorUnit = item.valorUnit.replace(',', '.')
            }
        },
        async carregarAta(id) {
            const response = await AtaService.findById(id);
            const ata = response.data;
            this.form = {
                id: ata.id,
                permiteCarona: ata.permiteCarona,
                processo: ata.processo,
                dataAssinatura: ata.dataAssinatura,
                dataPublicacao: ata.dataPublicacao,
                licitacao: ata.licitacao,
                valorTotalAta: ata.valorTotalAta,
                amparoLegal: ata.amparoLegal,
                numeroAta: ata.numeroAta,
                dataInicial: ata.dataInicial,
                dataFinal: ata.dataFinal,
                participantes: ata.participantes || [],
                itens: ata.itens || [],
                documentos: ata.documentos || [],
            }
        },
        abrirModalAdicionarDocumento() {
            this.$refs.fileInput.click()
        },
        async handleFileChange(event) {
            const file = event.target.files[0]
            if (file) {
                const arquivoBytes = await this.convertFileToBase64(file)
                this.form.documentos.push({
                    tipo: null,
                    descricao: "",
                    dataInclusao: new Date().toISOString().slice(0, 10),
                    arquivo: file,
                    nomeArquivo: file.name,
                    arquivoBytes: arquivoBytes,
                })
                this.$refs.fileInput.value = null
            }
        },
        validarGerenciador(participante) {
            const gerenciadores = this.form.participantes.filter(p => p.tipo === 1)
            if (gerenciadores.length > 1) {
                this.$bvToast.toast('Não é permitido adicionar mais de um gerenciador.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                participante.tipo = null
            }
        },
        calcularTotalItem(item) {
            const total = item.quantidade * item.valorUnit
            return isNaN(total) ? '0.00' : total.toFixed(2)
        },

        calcularQuantidadeTotal(item) {


            var total = 0;

            this.form.itens.forEach(produto => {


                if (!item || (produto.idProduto == item.idProduto))
                    total += parseInt(produto.quantidade);
            });
            return total;

        },
        calcularQuantidadeTotalParticipantes(item) {
            var total = 0;

            this.form.participantes.forEach(participante => {
                participante.itens.forEach(produto => {
                    if (!item || produto.idProduto == item.idProduto)
                        total += parseInt(produto.quantidade);
                });
            });
            return total;

        },

        baixarArquivo(arquivo) {
            downloadArquivo(arquivo)
        },
    },
}
</script>
